import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-dialog-message',
  templateUrl: './error-dialog-message.component.html',
  styleUrls: ['./error-dialog-message.component.css']
})
export class ErrorDialogMessageComponent implements OnInit {

  public message: string = "";
  constructor() { }

  ngOnInit(): void {
  }

}
